import {  useAuth0 } from "@auth0/auth0-react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";


const UserProfilePage = () => {

    const {user,isAuthenticated } = useAuth0();

  
  return (
    <>
      <Helmet>
        <title>Personalize Your Experience with Our User Profile Page</title>
        <meta property="og:title" content="Personalize Your Experience with Our User Profile Page"/>
        <meta property="og:site_name" content="Desire Store"/>
        <meta property="og:url" content="https://desirestore.online/user-profile"/>
        <meta property="og:description" content="Take control of your experience with our user profile page. By creating a profile, you can customize your preferences and settings to make our site work better for you. With the ability to update your personal information, manage your account settings, and view your order history, our user profile page offers a one-stop-shop for all your account needs. Plus, by staying logged in, you can access your profile from any device, making it easy to stay up-to-date on your orders and preferences."/>
        <meta property="og:type" content="website"/>
        <meta property="og:image" content="og-images/og-home.png"/>
        <link rel="canonical" href="https://desireStore.online/user-profile" />

        <meta name="title" content="Personalize Your Experience with Our User Profile Page"/>
        <meta name="description" data-rh="true" content="Take control of your experience with our user profile page. By creating a profile, you can customize your preferences and settings to make our site work better for you. With the ability to update your personal information, manage your account settings, and view your order history, our user profile page offers a one-stop-shop for all your account needs. Plus, by staying logged in, you can access your profile from any device, making it easy to stay up-to-date on your orders and preferences."/>
        <meta name="keywords" content="User profile page, customize, preferences, settings, personal information, account settings, order history, logged in, device, up-to-date"/>
      </Helmet>
    <div className="container">
    <main className="user-profile">
    <h2>Hello {isAuthenticated ? (user ? user.nickname : "Unknown User") : "User"}</h2>
    <img src={user ? user.picture : "images/user.jpg"} alt={isAuthenticated ? (user ? user.name : "Unknown User") : "User"} className="shadow"/>
    
    <table>
      <tr>
        <td> Name :</td>
        <td>{isAuthenticated ? (user ? user.nickname : " ") : "Login with Google"}</td>
      </tr>
      <tr>
        <td>Email :</td>
        <td>{isAuthenticated ? (user ? user.email : "N/A") : "Login with Google"}</td>
      </tr>
      <tr>
        <td>Phone :</td>
        <td> {isAuthenticated ? (user ? user.phone_number : " ") : "Login with Google"}</td>
      </tr>
      <tr>
        <td>Gender :</td>
        <td> {isAuthenticated ? (user ? user.gender : " ") : "Login with Google"}</td>
      </tr>
    </table>
    {
    
    isAuthenticated ? ( <></>  ):(<div className="joinNow">
    <Link to={"/login"}>
   <button>
Login Now
</button></Link>
   </div>)}

  </main>

    </div>
    </>
  );
};

export default UserProfilePage;
